<template>
  <div class="event-item">
    <a :href="event.url"
       :target="event.is_sports ? '_blank' : ''"
       class="event-item__title">
      {{ event.title }}
    </a>

    <ul class="event-item__details ignore-list">
      <li v-if="event.ics_url">
        <a :href="event.ics_url">
          <span v-html="assets.calendar"/>

          <time :datetime="event.formatted_date_range">
            {{ event.formatted_date_range }}
            <span v-if="event.status === 'Postponed'">
              (Postponed)
            </span>
            <span v-if="event.status === 'Cancelled'">
              (Cancelled)
            </span>
          </time>
        </a>
      </li>

      <li v-if="!event.ics_url">
        <span v-html="assets.calendar"/>

        <time :datetime="event.formatted_date_range">
          {{ event.formatted_date_range }}
          <span v-if="event.status === 'Postponed'">
            (Postponed)
          </span>
          <span v-if="event.status === 'Cancelled'">
            (Cancelled)
          </span>
        </time>
      </li>

      <li v-if="event.location && event.location_directions_url">
        <a :href="event.location_directions_url" target="_blank">
          <span v-html="assets.mapPin"/>

          {{ event.location }}{{ event.room_number && `, ${event.room_number}` }}
        </a>
      </li>

      <li v-if="event.location && !event.location_directions_url">
        <span v-html="assets.mapPin"/>

        {{ event.location }}{{ event.room_number && `, ${event.room_number}` }}
      </li>
    </ul>

    <div class="event-item__description">
      <p>{{ event.description }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Event',

  props: {
    event: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState([
      'assets'
    ])
  }
}
</script>
